import { jsx as _jsx } from "react/jsx-runtime";
import hotToast from 'react-hot-toast';
import { CheckCircleIcon } from '@repo/icons';
import CustomToast from '../components/CustomToast';
import { getLabels } from '../labels';
import { resolveToastId } from '../utils/resolveToastId';
export const success = (message, testId, options) => {
    const id = resolveToastId('success', message, options);
    const resolvedOptions = id ? { ...options, id } : options;
    const labels = getLabels();
    return hotToast.custom((toast) => (_jsx(CustomToast, { message: message, hotToast: hotToast, isVisible: toast.visible, id: toast.id, className: "bg-success-soft border-stroke-success-subtle text-success-strong", defaultIcon: _jsx(CheckCircleIcon, { size: 20 }), testId: testId, closeLabel: labels.close, options: options })), resolvedOptions);
};
